export const WIDGETS_AUTHENTICATED = 'WIDGETS_AUTHENTICATED';

export const setIsWidgetsAuthenticated = (isWidgetsAuthenticated) => ({
    type: WIDGETS_AUTHENTICATED,
    payload: isWidgetsAuthenticated
});
